// Action types (kept as strings for JS app compatibility)
export const FETCH_SITE_IN_A_BOX_ITEMS_REQUEST = "FETCH_SITE_IN_A_BOX_ITEMS_REQUEST";
export const FETCH_SITE_IN_A_BOX_ITEMS_SUCCESS = "FETCH_SITE_IN_A_BOX_ITEMS_SUCCESS";
export const FETCH_SITE_IN_A_BOX_ITEMS_FAILURE = "FETCH_SITE_IN_A_BOX_ITEMS_FAILURE";
export const FETCH_SITE_IN_A_BOX_ITEM_REQUEST = "FETCH_SITE_IN_A_BOX_ITEM_REQUEST";
export const FETCH_SITE_IN_A_BOX_ITEM_SUCCESS = "FETCH_SITE_IN_A_BOX_ITEM_SUCCESS";
export const FETCH_SITE_IN_A_BOX_ITEM_FAILURE = "FETCH_SITE_IN_A_BOX_ITEM_FAILURE";
export const ADD_SITE_IN_A_BOX_ITEM_REQUEST = "ADD_SITE_IN_A_BOX_ITEM_REQUEST";
export const ADD_SITE_IN_A_BOX_ITEM_SUCCESS = "ADD_SITE_IN_A_BOX_ITEM_SUCCESS";
export const ADD_SITE_IN_A_BOX_ITEM_FAILURE = "ADD_SITE_IN_A_BOX_ITEM_FAILURE";
export const EDIT_SITE_IN_A_BOX_ITEM_REQUEST = "EDIT_SITE_IN_A_BOX_ITEM_REQUEST";
export const EDIT_SITE_IN_A_BOX_ITEM_SUCCESS = "EDIT_SITE_IN_A_BOX_ITEM_SUCCESS";
export const EDIT_SITE_IN_A_BOX_ITEM_FAILURE = "EDIT_SITE_IN_A_BOX_ITEM_FAILURE";
export const DELETE_SITE_IN_A_BOX_ITEM_REQUEST = "DELETE_SITE_IN_A_BOX_ITEM_REQUEST";
export const DELETE_SITE_IN_A_BOX_ITEM_SUCCESS = "DELETE_SITE_IN_A_BOX_ITEM_SUCCESS";
export const DELETE_SITE_IN_A_BOX_ITEM_FAILURE = "DELETE_SITE_IN_A_BOX_ITEM_FAILURE";
export const SEND_EMAIL_REQUEST = "SEND_EMAIL_REQUEST";
export const SEND_EMAIL_SUCCESS = "SEND_EMAIL_SUCCESS";
export const SEND_EMAIL_FAILURE = "SEND_EMAIL_FAILURE";
export const SET_SITE_IN_A_BOX_PAGINATION = "SET_SITE_IN_A_BOX_PAGINATION";
export const SET_SITE_IN_A_BOX_FILTERS = "SET_SITE_IN_A_BOX_FILTERS";
export const CLEAR_SITE_IN_A_BOX_ERROR = "CLEAR_SITE_IN_A_BOX_ERROR";
export const GET_SITE_IN_A_BOX_DOC_URL = "GET_SITE_IN_A_BOX_DOC_URL";
export const SET_SITE_IN_A_BOX_SITE_DETAILS = "SET_SITE_IN_A_BOX_SITE_DETAILS";
export const SET_SITE_IN_A_BOX_CONNECTIVITY_DEFAULTS = "SET_SITE_IN_A_BOX_CONNECTIVITY_DEFAULTS";
